export default __webpack_public_path__ + "static/media/gallery_02.e65a1d71.jpg";